var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 79",
    d: "M-52 -22H274V999H-29.5C-41.9264 999 -52 988.926 -52 976.5V-22Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0599 22.0005H13.7256C12.6562 22.0005 11.7856 21.1299 11.7856 20.0606V12.1548C11.7856 11.0854 12.6562 10.2148 13.7256 10.2148H20.0599C21.1293 10.2148 21.9999 11.0854 21.9999 12.1548V20.0606C21.9999 21.1299 21.1293 22.0005 20.0599 22.0005ZM13.7256 11.7863C13.5221 11.7863 13.3571 11.9513 13.3571 12.1548V20.0606C13.3571 20.2641 13.5221 20.4291 13.7256 20.4291H20.0599C20.2634 20.4291 20.4284 20.2641 20.4284 20.0606V12.1548C20.4284 11.9513 20.2634 11.7863 20.0599 11.7863H13.7256Z",
    fill: "#474747"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.0599 8.6428H13.7256C12.6562 8.6428 11.7856 7.77224 11.7856 6.70289V1.93992C11.7856 0.870566 12.6562 0 13.7256 0H20.0599C21.1293 0 21.9999 0.870566 21.9999 1.93992V6.70289C21.9999 7.77224 21.1293 8.6428 20.0599 8.6428ZM13.7256 1.57142C13.5221 1.57142 13.3571 1.73642 13.3571 1.93992V6.70289C13.3571 6.90638 13.5221 7.07138 13.7256 7.07138H20.0599C20.2634 7.07138 20.4284 6.90638 20.4284 6.70289V1.93992C20.4284 1.73642 20.2634 1.57142 20.0599 1.57142H13.7256Z",
    fill: "#474747"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.2743 11.7856H1.93992C0.870566 11.7856 0 10.9151 0 9.84572V1.93992C0 0.870566 0.870566 0 1.93992 0H8.2743C9.34365 0 10.2142 0.870566 10.2142 1.93992V9.84572C10.2142 10.9151 9.34365 11.7856 8.2743 11.7856ZM1.93992 1.57142C1.73642 1.57142 1.57142 1.73642 1.57142 1.93992V9.84572C1.57142 10.0492 1.73642 10.2142 1.93992 10.2142H8.2743C8.4778 10.2142 8.6428 10.0492 8.6428 9.84572V1.93992C8.6428 1.73642 8.4778 1.57142 8.2743 1.57142H1.93992Z",
    fill: "#474747"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.2743 21.9992H1.93992C0.870566 21.9992 0 21.1287 0 20.0593V15.2964C0 14.227 0.870566 13.3564 1.93992 13.3564H8.2743C9.34365 13.3564 10.2142 14.227 10.2142 15.2964V20.0593C10.2142 21.1287 9.34365 21.9992 8.2743 21.9992ZM1.93992 14.9279C1.73642 14.9279 1.57142 15.0929 1.57142 15.2964V20.0593C1.57142 20.2628 1.73642 20.4278 1.93992 20.4278H8.2743C8.4778 20.4278 8.6428 20.2628 8.6428 20.0593V15.2964C8.6428 15.0929 8.4778 14.9279 8.2743 14.9279H1.93992Z",
    fill: "#474747"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.38d3b53d677d25d2fe7add128b34a2b9.svg";
export { ForwardRef as ReactComponent };